<template>
    <menu-top/>
</template>

<script>
    import MenuTop from "_private/components/smart/layout/menuTop";

    export default {
        components: {
            MenuTop
        }
    };
</script>
